// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

// import scene css modules
import sceneStyles from '../sceneModuleStyles.css';

// import form components
import {
  SelectFromArray
  , UrlInput
} from '../../../global/components/forms';

function VideoTrackListItem({
  deleteTrack
  // NOTE: formType was not being used before, now I am using it to keep track of which video we are adding subtitles to. We may want to change the name.
  , formType
  , handleTrackFormChange
  , index
  , track
  , trackLabels
}) {
  return (
    <div className="yt-row with-gutters">
      <div className="yt-col full _50">
        <UrlInput
          change={(e) => handleTrackFormChange(e, index, formType)}
          helpText={"MUST end in .vtt! i.e. 'https://redstone.com/visits/123.vtt'"}
          label="Track URL"
          name="file"
          required={false}
          validate={true}
          value={track.file}
        />
      </div>
      <div className="yt-col full _40">
        <SelectFromArray
          change={(e) => handleTrackFormChange(e, index, formType)}
          items={trackLabels}
          label="Track Label"
          name="label"
          placeholder="-- Select a Track Label -- "
          value={track.label}
        />
      </div>
      <div className="yt-col full _10">
        <button style={{padding:6}} type="button" className="yt-btn danger" onClick={() => deleteTrack(index, formType)}> &times;  </button>
      </div>
    </div>
  )
}

VideoTrackListItem.propTypes = {
  deleteTrack: PropTypes.func.isRequired
  , formType: PropTypes.string
  , handleTrackFormChange: PropTypes.func.isRequired
  , index: PropTypes.number.isRequired
  , track: PropTypes.object.isRequired
}

VideoTrackListItem.defaultProps = {
  formType: 'new'
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    trackLabels: store.scene.trackLabels
  }
}

export default connect(
  mapStoreToProps
)(VideoTrackListItem);



// WEBPACK FOOTER //
// modules/scene/components/VideoTrackListItem.js.jsx